import React from 'react';
import calculator from '../partials/CalculatorHOC';
import {
  Row,
  Col,
  ButtonGroup,
  Button,
  FormGroup,
  FormControl,
  ControlLabel
} from 'react-bootstrap';
import { PlanSelectorBox } from './';
import _ from 'lodash';

class CanvassingPlanCalculator extends React.Component {
  constructor(props) {
    super(props);

    this.handleIntervalChange = this.handleIntervalChange.bind(this);
  }

  handleIntervalChange(interval, plan) {
    this.props.handleIntervalChange(interval, plan);
  }
  render() {
    const { plans } = this.props;
    return (
      <div className='animated fadeIn'>
        <Row>
          {_.uniqBy(plans, 'name').map((plan, idx, plans_list) => {
            const { amount: month_plan_price } = plans.find(p => p.name == plan.name && p.interval == 'month');
            const { amount: year_plan_price } = plans.find(p => p.name == plan.name && p.interval == 'year');
            const current_item = this.props.canvassing_items.find(item => item.plan.name == plan.name) || { plan: {} };
            return (
              <Col
                md={plans_list.length == 1 ? 6 : 4}
                mdOffset={plans_list.length == 1 ? 3 : 0}
                xs={12}
                key={plan._id}
                >
                <PlanSelectorBox
                  show_icon={true}
                  icon_class='fa fa-map-marker'
                  title={plan.name}
                  body={plan.description}
                  type='success'
                  onMonthClick={() => this.handleIntervalChange('month', plan)}
                  month_selected={current_item.plan.interval == 'month'}
                  onYearClick={() => this.handleIntervalChange('year', plan)}
                  year_selected={current_item.plan.interval == 'year'}
                  prices={{ month: month_plan_price, year: year_plan_price }}
                  handleQuantityChange={e => this.props.handleQuantityChange(plan, e.target.value)}
                  quantity_input_disabled={current_item.plan.interval == null}
                  quantity_value={current_item.quantity}
                />
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }
}

module.exports = calculator(CanvassingPlanCalculator);



// WEBPACK FOOTER //
// ./src/browser/components/settings/subscriptions/plans_calculator/partials/CanvassingPlanCalculator.js